<script setup lang="ts">
import AdminGamesTable from '@/views/pages/games/AdminGamesTable.vue'

definePage({
  meta: {
    action: 'manage',
    subject: 'all',
  },
})
</script>

<template>
  <AdminGamesTable
    show-add-button
    :for-participant="false"
    :for-expert="false"
    :player-id="null"
  />
</template>

<style lang="scss">
.ProseMirror-focused{
  border: none;
}
</style>
